import React, { Component } from "react";
import firebase from "../../firebase";
import { Redirect } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    backgroundColor: "#fff",
    padding: "20px 20px 40px 20px"
  }
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: props.loggedIn,
      email: "",
      password: "",
      uid: "",
      warning: false
    };
  }

  handleInput = e => {
    let { value } = e.target;
    this.setState({ [e.target.name]: value, warning: false });
  };

  login = e => {
    e.preventDefault();
    let { email, password } = this.state;
    if (!email || !password) return this.setState({ warning: true });

    let auth = firebase.auth();
    auth.signInWithEmailAndPassword(email, password).catch(err => {
      this.setState({ failure: true });
      console.error(`Sign in failed: ${err}`);
    });
    auth.onAuthStateChanged(usr => {
      if (usr) {
        this.setState(
          { email: usr.email, uid: usr.uid, loggedIn: true },
          () => {
            console.log(this.state.uid);
            this.props.isLoggedIn(this.state.email, this.state.uid);
          }
        );
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <section className="login-form-section">
        {this.props.loggedIn ? <Redirect to="/admin" /> : null}

        {this.state.failure === true ? (
          <p className="alert alert-danger text-center">
            The entered credentials do not match our records. If you believe
            this is a mistake, please contact systems adminstrator
          </p>
        ) : null}
        <h2 className="text-center login-title">
          Minerva Web Development, Inc.
        </h2>
        <article className="login-form-inner large-wrapper">
          <FormGroup className={classes.root}>
            {this.state.warning === true ? (
              <p className="alert alert-warning">
                Email and password must be filled out
              </p>
            ) : null}
            <TextField
              id="textarea"
              label="Enter Your Email"
              placeholder="Email"
              multiline
              margin="normal"
              name="email"
              onChange={this.handleInput}
            />
            <TextField
              id="password-input"
              label="Password"
              type="password"
              margin="normal"
              name="password"
              onChange={this.handleInput}
            />
            <Button variant="contained" color="primary" onClick={this.login}>
              Send
            </Button>
          </FormGroup>
        </article>
      </section>
    );
  }
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/admin/components/Login.js